import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16674f0f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notification" }
const _hoisted_2 = {
  key: 0,
  class: "notification__unread"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = {
  key: 0,
  class: "text"
}
const _hoisted_7 = {
  key: 1,
  class: "text"
}
const _hoisted_8 = {
  key: 2,
  class: "text"
}
const _hoisted_9 = {
  key: 3,
  class: "request request-accept"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" }, null, -1))
const _hoisted_11 = { class: "text" }
const _hoisted_12 = {
  key: 4,
  class: "request request-decline"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_14 = { class: "text" }
const _hoisted_15 = {
  key: 5,
  class: "request request-decline"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_17 = { class: "text" }
const _hoisted_18 = {
  key: 6,
  class: "text"
}
const _hoisted_19 = {
  key: 7,
  class: "request request-accept"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" }, null, -1))
const _hoisted_21 = { class: "text" }
const _hoisted_22 = {
  key: 8,
  class: "request request-decline"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_24 = { class: "text" }
const _hoisted_25 = {
  key: 9,
  class: "text"
}
const _hoisted_26 = {
  key: 10,
  class: "text"
}
const _hoisted_27 = {
  key: 11,
  class: "text"
}
const _hoisted_28 = {
  key: 12,
  class: "request request-accept"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" }, null, -1))
const _hoisted_30 = { class: "text" }
const _hoisted_31 = {
  key: 13,
  class: "request request-decline"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_33 = { class: "text" }
const _hoisted_34 = {
  key: 14,
  class: "request request-accept"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" }, null, -1))
const _hoisted_36 = { class: "text" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "sub-text" }
const _hoisted_40 = {
  key: 1,
  class: "controll"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" }, null, -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = {
  key: 2,
  class: "controll"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" }, null, -1))
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = {
  key: 3,
  class: "controll"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" }, null, -1))
const _hoisted_54 = [
  _hoisted_53
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_item_case = _resolveComponent("item-case")!
  const _component_item_file = _resolveComponent("item-file")!
  const _component_item_photo = _resolveComponent("item-photo")!
  const _component_item_folder = _resolveComponent("item-folder")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.unread)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "avatar",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.viewProfile && _ctx.viewProfile(...args)))
    }, [
      _createElementVNode("img", {
        src: _ctx.photoUrl,
        alt: "user avatar"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", _hoisted_5, [
        _createElementVNode("span", {
          class: "bold-text",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.viewProfile && _ctx.viewProfile(...args)))
        }, _toDisplayString(_ctx.alertTitle), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.alertText), 1)
      ]),
      (_ctx.notification.type === _ctx.NOTIFICATION_TYPE.GROUP_REQUEST_SENT && !_ctx.notification.status)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$localize('group.connect.with.you')), 1))
        : _createCommentVNode("", true),
      (_ctx.notification.type === _ctx.NOTIFICATION_TYPE.GROUP_REQUEST_SENT
           && _ctx.notification.status === _ctx.NOTIFICATION_STATUS.ACCEPTED)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$localize('group.request.you.accepted')), 1))
        : _createCommentVNode("", true),
      (_ctx.notification.type === _ctx.NOTIFICATION_TYPE.GROUP_REQUEST_SENT
           && _ctx.notification.status === _ctx.NOTIFICATION_STATUS.REJECTED)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.$localize('group.request.you.rejected')), 1))
        : _createCommentVNode("", true),
      (_ctx.notification.type === _ctx.NOTIFICATION_TYPE.GROUP_REQUEST_ACCEPT)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.fullName) + " " + _toDisplayString(_ctx.$localize('group.request.accepted')), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.notification.type === _ctx.NOTIFICATION_TYPE.GROUP_REQUEST_REJECT)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.fullName) + " " + _toDisplayString(_ctx.$localize('group.request.rejected')), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.notification.type === _ctx.NOTIFICATION_TYPE.USER_LEFT_THE_GROUP)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.fullName) + " " + _toDisplayString(_ctx.$localize('group.user.left')), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.notification.type === _ctx.NOTIFICATION_TYPE.REMOVED_FROM_GROUP)
        ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.$localize('group.remove.you')), 1))
        : _createCommentVNode("", true),
      (_ctx.notification.type === _ctx.NOTIFICATION_TYPE.IN_GROUP_REQUEST_ACCEPT)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$localize('group.accepted.you')), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.notification.type === _ctx.NOTIFICATION_TYPE.IN_GROUP_REQUEST_REJECT)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$localize('group.rejected.you')), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.notification.type === _ctx.NOTIFICATION_TYPE.CONTACT_REQUEST_SENT && !_ctx.notification.status)
        ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.$localize('connect.with.you')), 1))
        : _createCommentVNode("", true),
      (_ctx.notification.type === _ctx.NOTIFICATION_TYPE.CONTACT_REQUEST_SENT
           && _ctx.notification.status === _ctx.NOTIFICATION_STATUS.ACCEPTED)
        ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.$localize('contact.request.you.accepted')), 1))
        : _createCommentVNode("", true),
      (_ctx.notification.type === _ctx.NOTIFICATION_TYPE.CONTACT_REQUEST_SENT
           && _ctx.notification.status === _ctx.NOTIFICATION_STATUS.REJECTED)
        ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(_ctx.$localize('contact.request.you.rejected')), 1))
        : (_ctx.notification.type === _ctx.NOTIFICATION_TYPE.CONTACT_REQUEST_ACCEPT)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$localize('contact.request.accepted')), 1)
            ]))
          : (_ctx.notification.type === _ctx.NOTIFICATION_TYPE.CONTACT_REQUEST_REJECT)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.$localize('contact.request.rejected')), 1)
              ]))
            : _createCommentVNode("", true),
      (_ctx.notification.type === _ctx.NOTIFICATION_TYPE.ADDED_TO_GROUP)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$localize('group.added.you')), 1)
          ]))
        : (_ctx.notification.type === _ctx.NOTIFICATION_TYPE.SHARE_CASE)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 15 }, [
              (_ctx.sharedCase)
                ? (_openBlock(), _createBlock(_component_item_case, {
                    key: 0,
                    onClick: _ctx.viewCase,
                    iCase: _ctx.sharedCase,
                    hideTitle: "",
                    "is-hmed": ""
                  }, null, 8, ["onClick", "iCase"]))
                : _createCommentVNode("", true)
            ], 64))
          : (_ctx.notification.type === _ctx.NOTIFICATION_TYPE.SHARE_FILE)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 16 }, [
                (_ctx.mainStore.isMobile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      (_ctx.sharedMedia && _ctx.sharedMedia.type === _ctx.MEDIA_TYPES.FILES)
                        ? (_openBlock(), _createBlock(_component_item_file, {
                            key: 0,
                            file: _ctx.sharedMedia,
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.viewFile(_ctx.sharedMedia!))),
                            hideTitle: "",
                            hideAuthor: "",
                            class: "w-120"
                          }, null, 8, ["file"]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      (_ctx.sharedMedia && _ctx.sharedMedia.type === _ctx.MEDIA_TYPES.FILES)
                        ? (_openBlock(), _createBlock(_component_item_file, {
                            key: 0,
                            file: _ctx.sharedMedia,
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.viewFile(_ctx.sharedMedia!))),
                            hideTitle: "",
                            hideAuthor: "",
                            class: "w-120",
                            preventOpen: ""
                          }, null, 8, ["file"]))
                        : _createCommentVNode("", true)
                    ])),
                (_ctx.sharedMedia && (_ctx.sharedMedia.type === _ctx.MEDIA_TYPES.PHOTO || _ctx.sharedMedia.type === _ctx.MEDIA_TYPES.VIDEO))
                  ? (_openBlock(), _createBlock(_component_item_photo, {
                      key: 2,
                      photo: _ctx.sharedMedia,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.viewPhoto(_ctx.sharedMedia!))),
                      "hide-title": "",
                      "is-hmed": ""
                    }, null, 8, ["photo"]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_ctx.notification.type === _ctx.NOTIFICATION_TYPE.SHARE_FOLDER)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 17 }, [
                  (_ctx.sharedFolder)
                    ? (_openBlock(), _createBlock(_component_item_folder, {
                        key: 0,
                        class: "mr-auto",
                        folder: _ctx.sharedFolder,
                        hideTitle: "",
                        hideAuthor: "",
                        onOpenFolder: _ctx.viewFolder
                      }, null, 8, ["folder", "onOpenFolder"]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.date), 1)
    ]),
    (_ctx.notification.type === _ctx.NOTIFICATION_TYPE.CONTACT_REQUEST_SENT && !_ctx.notification.status)
      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
          _createElementVNode("div", {
            class: "icon-wrapper decline",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.manageContact(_ctx.notification.partnerId.internalId)))
          }, _hoisted_42),
          _createElementVNode("div", {
            class: "icon-wrapper accept",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.manageContact(_ctx.notification.partnerId.internalId, true)))
          }, _hoisted_44)
        ]))
      : _createCommentVNode("", true),
    (_ctx.notification.type === _ctx.NOTIFICATION_TYPE.GROUP_REQUEST_SENT && !_ctx.notification.status)
      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
          _createElementVNode("div", {
            class: "icon-wrapper decline",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.manageGroup(_ctx.notification.sharedInfo.id, _ctx.notification.partnerId.internalId)))
          }, _hoisted_47),
          _createElementVNode("div", {
            class: "icon-wrapper accept",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.manageGroup(_ctx.notification.sharedInfo.id, _ctx.notification.partnerId.internalId, true)))
          }, _hoisted_49)
        ]))
      : _createCommentVNode("", true),
    (_ctx.notification.type === _ctx.NOTIFICATION_TYPE.IN_GROUP_REQUEST_SENT && !_ctx.notification.status)
      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
          _createElementVNode("div", {
            class: "icon-wrapper decline",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.manageRequestToGroup(_ctx.notification.sharedInfo.id, _ctx.notification.partnerId.internalId)))
          }, _hoisted_52),
          _createElementVNode("div", {
            class: "icon-wrapper accept",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.manageRequestToGroup(_ctx.notification.sharedInfo.id, _ctx.notification.partnerId.internalId, true)))
          }, _hoisted_54)
        ]))
      : _createCommentVNode("", true)
  ]))
}